// extracted by mini-css-extract-plugin
export default {"results_container":"Results_results_container__Da3dZ","button":"Results_button__Fo6Bf"};